module.exports = __webpack_public_path__ + "static/media/Yankee.4cf0a2a6.jpg";